import {useEffect, useState} from "react";

/**
 * 지연된 로딩 표시 커스텀 훅
 * 로딩이 지정된 지연 시간 (기본 3초) 이상 걸릴 때만 로딩 화면을 표시합니다.
 * 이는 짧은 로딩 시 깜빡임 방지하고 더 나은 UX 제공
 *
 * @param actualLoading - 실제 로딩 상태
 * @param delay - 로딩 표시 지연 시간 (ms, 기본값: 3000ms = 3초)
 * @returns 지연된 로딩 상태
 */
export const useDelayedLoading = (actualLoading: boolean, delay = 3000): boolean => {
    const [showLoading, setShowLoading] = useState<boolean>(false);

    useEffect(() => {
        let timeoutId: NodeJS.Timeout;

        if (actualLoading) {
            // 로딩이 시작되면 지연 시간 후에 로딩 화면 표시
            timeoutId = setTimeout(() => {
                setShowLoading(true);
            }, delay);
        } else {
            // 로딩이 끝나면 즉시 로딩 화면 숨김
            setShowLoading(false);
        }

        return () => {
            if (timeoutId) {
                clearTimeout(timeoutId);
            }
        };
    }, [actualLoading, delay]);

    return showLoading;
};
